import { useCallback } from 'react';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './TrueColorButton.css';

import { setActiveSubLayer } from '../../../actions/layersActions';
import { useAppDispatch, useAppSelector } from '../../../utils';
import { getCurrentSeason, getFhaDate, getFhaSelectedSegment, getIsFhaSubLayerActive } from '../../../selectors';
import { FhaSegment, FHA_KEY } from '../../../types/Fha';

export type TrueColorButtonProps = {
  index: number;
}

export const TrueColorButton = ({ index }: TrueColorButtonProps) => {
  const dispatch = useAppDispatch();
  const currentSeason = useAppSelector(state => getCurrentSeason(state, { index }));
  const fhaDate = useAppSelector(state => getFhaDate(state, { index }));
  const isActive = useAppSelector(state => getIsFhaSubLayerActive(state, { index }));
  const segmentSelected = useAppSelector(state => getFhaSelectedSegment(state, { index }));

  const handleClick = useCallback((e: MouseEvent) => {
    e.preventDefault();
    const activeSubLayer = {
      layer: (isActive && segmentSelected) ? segmentSelected : FhaSegment.TRUE_COLOR,
      date: fhaDate,
      segmentSelected,
    };

    dispatch(setActiveSubLayer(FHA_KEY, activeSubLayer, index, currentSeason));
  }, [dispatch, isActive, segmentSelected, fhaDate, currentSeason, index]);

  const activeStyle = isActive ? styles.active : '';

  return (
    <Button
      className={`${styles.truecolor} ${activeStyle}`}
      data-test-id="true-color-btn"
      mode="map"
      onClick={handleClick}
    >
      {getMessage('trueColor')}
    </Button>
  );
};
